<template>
  <div id="editorPage" class="content" v-on:click="sectionClicked">
    <div class="getingData" v-if="getingData"></div>
    <div class="notFound" v-else-if="notFound">
      <div class="nfCnt">
        <img src="../assets/not-found.png">
        <h4>404 - Not Found</h4>
        <p>Maybe content you looking is for deleted or you click wrong button.</p>
      </div>
    </div>
    <div v-else>
      <div class="contentCnt">
        <div class="articleCnt">
          <template v-if="['article', 'link', 'event', 'file'].includes(type)
            && form.useHeaderImg.model === 1">
            <div class="headerImg" v-if="headerImg" v-on:click="addHeaderImg"
              :style="{'background-image': `url(${headerImg.imageLg})`}"
              :class="form.coverStyle.model">
              <img v-if="form.coverStyle.model === 'full'" :src="headerImg.imageLg">
              <div class="pdfOption">
                <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                  v-if="showPdfOptions"></div>
                <div class="optCnt" v-if="showPdfOptions">
                  <li v-on:click.stop="addHeaderImg">Change Header Image</li>
                  <li class="divider"></li>
                  <li class="red" v-on:click.stop="headerImg = null">Remove Image</li>
                </div>
              </div>
            </div>
            <div class="headerImg noImg" v-else v-on:click="addHeaderImg"></div>
          </template>
          <div class="attachmentCnt fileDownload" v-if="type === 'file'">
            <div class="attachmentItem" v-if="media" v-on:click="addPdf">
              <div class="attachmentIcon" v-if="media.type === 'image'"
                :style="{'background-image': `url(${media.imageTh})`}"
                :class="media.type"></div>
              <div class="attachmentIcon" v-else-if="media.type === 'video'"
                :style="{'background-image': `url(${media.mainThumb})`}"
                :class="media.type"></div>
              <div class="attachmentIcon" v-else :class="media.type"></div>
              <h4>{{media.name}}</h4>
              <!-- <div class="aIcon download"></div> -->
              <div class="aIcon edit"></div>
              <div class="aIcon delete" v-on:click.stop="media = null"></div>
            </div>
            <div class="attachmentItem" v-else v-on:click="addPdf">
              <div class="attachmentIcon add"></div>
              <h4>Add Downloadable File</h4>
            </div>
          </div>
          <template v-if="type === 'profile'">
            <div class="headerImg profile" v-if="headerImg" v-on:click="addPdf"
              :style="{'background-image': `url(${headerImg.imageLg})`}"
              :class="{full2: form.coverStyle.model === 'full'}">
              <div class="pdfOption">
                <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                  v-if="showPdfOptions"></div>
                <div class="optCnt" v-if="showPdfOptions">
                  <li v-on:click.stop="addPdf">Change Profile Picture</li>
                  <li class="divider"></li>
                  <li class="red" v-on:click.stop="headerImg = null">Remove Image</li>
                </div>
              </div>
            </div>
            <div class="headerImg profile noImg" v-else v-on:click="addPdf"></div>
          </template>
          <template v-else-if="type === 'video'">
            <div class="headerImg youtube"
              :class="{full2: form.coverStyle.model === 'full'}"
              v-if="media && media.mimetype === 'video/youtube'"
              v-on:click="doNothing"
              :style="{'background-image': `url(${media.mainThumb})`}">
              <iframe :src="media.embedUri" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                gyroscope; picture-in-picture" allowfullscreen
                ref="ytVideo"></iframe>
              <div class="coverImg" v-if="pdfCover && !videoPlaying"
                v-on:click="$refs.ytVideo.click(); videoPlaying = true"
                :style="{'background-image': `url(${pdfCover.imageMd})`}">
                <div class="playBtn"></div>
              </div>
              <div class="pdfOption">
                <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                  v-if="showPdfOptions"></div>
                <div class="optCnt" v-if="showPdfOptions">
                  <li v-on:click.stop="addPdf">Change Video</li>
                  <li v-on:click.stop="customCover">Custom Cover Image</li>
                  <li v-on:click.stop="resetCover">Reset Default Cover</li>
                  <li class="divider"></li>
                  <li class="red" v-on:click.stop="media = null">Remove Video</li>
                </div>
              </div>
            </div>
            <div class="headerImg video" v-else-if="media" v-on:click="doNothing"
              :class="{full2: form.coverStyle.model === 'full'}">
              <video controls ref="video" v-on:play="play = videoPlaying = true"
                v-on:ended="videoPlaying = false">
                <source :src="media.vid1080p" type="video/mp4" v-if="media.vid1080p">
                <source :src="media.vid720p" type="video/mp4" v-if="media.vid720p">
                <source :src="media.vid480p" type="video/mp4" v-if="media.vid480p">
                <source :src="media.vid360p" type="video/mp4" v-if="media.vid360p">
              </video>
              <div class="coverImg" v-if="pdfCover && !videoPlaying"
                v-on:click="$refs.video.play()"
                :style="{'background-image': `url(${pdfCover.imageMd})`}">
                <div class="playBtn"></div>
              </div>
              <div class="pdfOption">
                <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                  v-if="showPdfOptions"></div>
                <div class="optCnt" v-if="showPdfOptions">
                  <li v-on:click.stop="addPdf">Change Video</li>
                  <li v-on:click.stop="customCover">Custom Cover Image</li>
                  <li class="divider"></li>
                  <li class="red" v-on:click.stop="resetCover"
                    v-if="pdfCover">Reset Default Cover</li>
                  <li class="red" v-on:click.stop="showPdfOptions = false;
                    media = null;">Remove Video</li>
                </div>
              </div>
            </div>
            <div class="headerImg video noImg" v-else v-on:click="addPdf"></div>
          </template>
          <template v-else-if="type === 'audio'">
            <div class="thePdf forAudio" v-on:click.stop="doNothing">
              <div class="pdfOption">
                <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                  v-if="showPdfOptions"></div>
                <div class="optCnt" v-if="showPdfOptions">
                  <li v-on:click.stop="addPdf">Change Audio</li>
                  <li v-on:click.stop="customCover">Custom Cover Image</li>
                  <li class="divider"></li>
                  <li class="red" v-on:click.stop="resetCover"
                    v-if="pdfCover">Reset Default Cover</li>
                  <li class="red" v-on:click.stop="showPdfOptions = false;
                    media = null;">Remove Audio</li>
                </div>
              </div>
              <div class="audioAlbum" :style="{'background-image': `url(${pdfCover.imageMd})`}"
                v-if="pdfCover" v-on:click.stop="playPauseAudio"
                :class="form.coverStyle.model"></div>
              <div class="audioAlbum noImg" v-on:click.stop="playPauseAudio" v-else></div>
              <audio controls ref="audio" v-if="media">
                <source :src="media.audio" :type="media.mimetype" v-if="media.audio">
              </audio>
            </div>
          </template>
          <template v-else-if="type === 'gallery'">
            <div class="priceOk">
              <div class="priceNav p" v-if="galleryIdx > 0"
                v-on:click="galleryIdx -= 1"></div>
              <div class="priceNav n" v-if="gallery.length > 3 && galleryIdx < gallery.length - 3"
                v-on:click="galleryIdx += 1"></div>
              <div class="priceSc">
                <div class="prizeCnt" :style="{width: `${(gallery.length + 1) * 130}px`}"
                  :class="[`prize${galleryIdx}`]">
                  <div class="prizeItem" v-for="(item, i) in gallery" :key="i">
                    <div class="catImg hasImg" v-if="item" v-on:click.stop="editGallery(i, item)"
                      :style="{'background-image': `url(${item.imageMd})`}">
                      <div class="more" v-on:click.stop="showImgMore = i"></div>
                      <div class="moreMenu" v-if="showImgMore === i"
                        v-on:click.stop="doNothing">
                        <li v-on:click.stop="editGallery(i, item)">Change Image</li>
                        <li class="red" v-on:click.stop="deleteGallery(i, item)">Delete Image</li>
                      </div>
                    </div>
                    <div class="catImg" v-else v-on:click.stop="editGallery(i, item)">
                      <div class="more" v-on:click.stop="showImgMore = i"></div>
                      <div class="moreMenu" v-if="showImgMore === i"
                        v-on:click.stop="doNothing">
                        <li v-on:click.stop="editGallery(i, item)">Change Image</li>
                        <li class="red" v-on:click.stop="deleteGallery(i, item)">Delete Image</li>
                      </div>
                    </div>
                  </div>
                  <div class="catImg addPrize" v-on:click="addPdf">
                    <span><img src="../assets/photo-black.png"></span>
                    Add Image
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="type === 'pdf'">
            <div class="headerImg pdf" v-if="pdfCover || media" v-on:click="addPdf"
              :style="{'background-image': `url(${media ? media.cover : ''})`}"
              :class="form.coverStyle.model">
              <img v-if="form.coverStyle.model === 'full' && !pdfCover"
                :src="media.cover" class="imgFull">
              <div class="pdfCover crop" v-if="pdfCover && form.coverStyle.model === 'crop'"
                :style="{'background-image': `url(${pdfCover.imageMd})`}"></div>
              <div class="pdfCover full" v-else-if="pdfCover">
                <img :src="pdfCover.imageMd">
              </div>
              <div class="pdfOption">
                <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                  v-if="showPdfOptions"></div>
                <div class="optCnt" v-if="showPdfOptions">
                  <li v-on:click.stop="addPdf">Change PDF</li>
                  <li v-on:click.stop="customCover">Custom Cover Image</li>
                  <li class="divider"></li>
                  <li class="red" v-on:click.stop="resetCover">Reset Default Cover</li>
                  <li class="red" v-on:click.stop="showPdfOptions = false;
                    media = null">Remove PDF</li>
                </div>
              </div>
            </div>
            <div class="headerImg pdf noImg" v-else v-on:click="addPdf"></div>
          </template>
          <textarea class="articleTitle" rows="1"
            :placeholder="type && type === 'profile' ? 'Profile name...' : 'Title here...'"
            :style="{'height': titleMinHeight}" v-model="form.title.model"
            v-on:input="titleChanged" ref="title"/>
          <div class="fieldGroup userInfo" v-if="type === 'profile' && position">
            {{position}}
          </div>
          <div class="fieldGroup userInfo" v-if="1>2">
            <input type="text" class="field" placeholder="Additional information..."
              v-model="form.info.model">
          </div>
          <div class="titleError" v-if="form.title.error">Please input title.</div>
          <div class="authorInfo" :class="{noAuthor: !form.displayAuthor.model}">
            <div :class="{authorImg: true, hasPhoto: $session.get(`${$config.appId}_avatar`)}"
              :style="{'background-image': `url('${$session.get(`${$config.appId}_avatar`)}')`}"
              v-if="form.displayAuthor.model">
              <span v-if="$session.get(`${$config.appId}_name`)">
                {{$session.get(`${$config.appId}_name`).substr(0,2)}}</span>
            </div>
            <h4 v-if="form.displayAuthor.model">{{$session.get(`${$config.appId}_name`)}}</h4>
            <div class="publishTime">
              <template v-if="form.displayPublishDate.model">
                <span>{{pt | moment('D MMMM YYYY HH:mm')}}</span>
                <span class="bull">&bull;</span>
              </template>
              <template v-if="form.displayViews.model">
                <span>
                  <template v-if="viewCount > 1">
                    <template v-if="viewCount >= 1000000000">
                      {{Math.floor(viewCount/1000000000).toLocaleString('id')}}b
                    </template>
                    <template v-else-if="viewCount >= 1000000">
                      {{Math.floor(viewCount/1000000).toLocaleString('id')}}m
                    </template>
                    <template v-if="viewCount >= 1000">
                      {{Math.floor(viewCount/1000).toLocaleString('id')}}k
                    </template>
                    <template v-else-if="viewCount">
                      {{viewCount.toLocaleString('id')}}
                    </template>
                    views
                  </template>
                  <template v-else>{{viewCount || 0}} view</template>
                </span>
                <span class="bull">&bull;</span>
              </template>
              <span class="label type" :class="type" v-if="type">
                {{type.substr(0, 1).toUpperCase()}}{{type.substr(1)}}
              </span>
            </div>
          </div>
          <Editor ref="editor" v-model="form.content.model"
            :content="form.content.content"/>
          <div class="attachmentCnt" v-if="attachments.length > 0">
            <h4 class="aTitle">Attachment</h4>
            <div class="attachmentItem" v-for="(att, i) in attachments" :key="`att${i}`">
              <div class="attachmentIcon" v-if="att.type === 'image'"
                :style="{'background-image': `url(${att.imageTh})`}"
                :class="att.type"></div>
              <div class="attachmentIcon" v-else-if="att.type === 'video'"
                :style="{'background-image': `url(${att.mainThumb})`}"
                :class="att.type"></div>
              <div class="attachmentIcon" v-else :class="att.type"></div>
              <h4>{{att.name}}</h4>
              <!-- <div class="aIcon download"></div> -->
              <div class="aIcon edit" v-on:click="editAtt(i, att)"></div>
              <div class="aIcon delete" v-on:click="deleteAtt(i, att)"></div>
            </div>
          </div>
          <div class="sectionCnt" v-if="sectionData.length > 0">
            <h4 class="sTitle">Sections</h4>
            <SectionData :sectionData="sectionData" class="fromArticle"
              v-on:change="sectionChanged" v-on:click="sectionClicked"/>
          </div>
        </div>
      </div>

      <div class="cmsriverCnt" :class="{loading: loadingGPT}">
        <div class="cmsriverResult" :class="{open: gptResultOpen}">
          <div class="text" v-html="gptResult"></div>
          <div class="actions">
            <button class="btn btnSecondary"
              v-on:click="gptResultOpen = false">Close</button>
            <button class="btn btnPrimary" v-if="gptType !== 'analyze'"
              v-on:click="applyToArticle">Apply to article</button>
          </div>
        </div>
        <div class="cmsriver" v-on:click="openAiDialog">
          <div class="info">
            Open CMSRiver AI
          </div>
        </div>
      </div>
      <div class="formAction">
        <div class="formActionCnt">
          <div class="categoryCnt">
            <div class="theBtn lang" v-on:click="openLangSelector = true">
              <b>{{lang}}</b>
            </div>
            <div class="configOverlay" v-if="openLangSelector"
              v-on:click="openLangSelector = false"></div>
            <div class="configContent" v-if="openLangSelector">
              <div class="configItem">
                <h4>Select Language</h4>
                <div class="ciItem" v-on:click.stop="selectLang('en')">
                  EN - English</div>
                <div class="ciItem" v-on:click.stop="selectLang('id')">
                  ID - Bahasa Indonesia</div>
              </div>
            </div>
          </div>
          <div class="categoryCnt">
            <div class="theBtn date" v-on:click="openDateSelector = true">
              <b>{{pt | moment('D MMM YYYY HH:mm')}}</b>
            </div>
            <div class="configOverlay" v-if="openDateSelector"
              v-on:click="openDateSelector = false"></div>
            <div class="configContent datePicker" v-if="openDateSelector">
              <DatePicker title-position="left"
                v-model="pt" mode="dateTime" timezone="">
              </DatePicker>
            </div>
          </div>
          <div class="categoryCnt">
            <div class="theBtn category" v-on:click="changeCategory">
              <template v-if="category.length > 0">
                <b>
                  {{category[0].name[lang]}}
                  <template v-if="category.length > 1">
                    +{{category.length - 1}} more
                  </template>
                </b>
              </template>
              <template v-else>Category</template>
            </div>
          </div>
          <div class="categoryCnt">
            <div class="theBtn section" v-on:click="addSection">
              <template>
                Section
              </template>
            </div>
          </div>
          <div class="saveBtnCnt canSaveDraft"
            :class="{loading: saving, disabled: btnDisabled}">
            <button :class="{btn: true, btnPrimary: true, disabled: false, btnLoading: saving}"
              v-on:click="doSave('published')">
              <span>Publish</span>
            </button>
            <div class="moreBtn" v-on:click="openMoreOptions"></div>
            <div class="moreOptionOverlay" v-if="showMoreOptions && !btnDisabled"
              v-on:click="showMoreOptions = false"></div>
            <div class="moreOption" v-if="showMoreOptions && !btnDisabled">
              <li v-on:click="doSave('draft')" class="draft">Save as Draft</li>
              <li v-on:click="preview" class="preview">Preview</li>
            </div>
          </div>

          <div class="btnConfig" v-if="!saving">
            <div class="theBtn" v-on:click.stop="configOpen = !configOpen;
              metadataOpen = false"></div>
            <div class="configContent hasSc" v-if="configOpen"
              v-on:click.stop="configCntClicked">
              <div class="configSc">
                <div class="configItem">
                  <h4 class="h4ci">Article Info</h4>
                  <div class="ciItem">
                    Status
                    <span v-if="editData">{{editData.status.substr(0,1).toUpperCase()}}{{
                    editData.status.substr(1)}}</span>
                    <span v-else>Published</span>
                  </div>
                  <div class="ciItem hasDd" v-if="selectedAuthor">
                    Author
                    <div v-bind:class="{dd: true, open: ddOpenAuthor}"
                      v-on:click.stop="ddOpenAuthor = !ddOpenAuthor">
                      {{selectedAuthor.name}}
                      <div class="ddMenu" v-if="ddOpenAuthor">
                        <div class="ddSc">
                          <li v-for="(item, i) in authors" :key="i"
                            v-on:click.stop="selectAuthor(item)">
                            <h4>{{item.name}}</h4>
                            <p>
                              {{item.role.name}}
                              <span class="bull">&bull;</span>
                              {{item.email}}
                            </p>
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div class="ciItem hasDd">
                    Type
                    <div v-bind:class="{dd: true, open: ddType}"
                      v-on:click.stop="ddType = !ddType">
                      <template v-if="type === 'gallery'">Image Gallery</template>
                      <template v-else-if="type === 'pdf'">PDF Document</template>
                      <template v-else>
                        {{type.substr(0,1).toUpperCase()}}{{type.substr(1)}}
                      </template>
                      <div class="ddMenu" v-if="ddType">
                        <div class="ddSc">
                          <li v-on:click.stop="type = 'article'; ddType = false">
                            <h4>Article</h4>
                            <p>Article text for story.</p>
                          </li>
                          <li v-on:click.stop="type = 'video'; ddType = false">
                            <h4>Video</h4>
                            <p>Video content single page.</p>
                          </li>
                          <li v-on:click.stop="type = 'audio'; ddType = false">
                            <h4>Audio</h4>
                            <p>Audio or podcast.</p>
                          </li>
                          <li v-on:click.stop="type = 'gallery'; ddType = false">
                            <h4>Image Gallery</h4>
                            <p>Single or multiple image displayed as gallery.</p>
                          </li>
                          <li v-on:click.stop="type = 'pdf'; ddType = false">
                            <h4>PDF Document</h4>
                            <p>PDF Document displayed with PDF Viewer.</p>
                          </li>
                          <li v-on:click.stop="type = 'event'; ddType = false">
                            <h4>Event Calendar</h4>
                            <p>Add new an event in calendar.</p>
                          </li>
                          <li v-on:click.stop="type = 'profile'; ddType = false">
                            <h4>Profile</h4>
                            <p>User profile view.</p>
                          </li>
                          <li v-on:click.stop="type = 'file'; ddType = false">
                            <h4>File Download</h4>
                            <p>Any file that be download by visitor.</p>
                          </li>
                          <li v-on:click.stop="type = 'link'; ddType = false">
                            <h4>External Link</h4>
                            <p>Content that link to another website.</p>
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                    <div class="clear"></div>
                  </div>
                  <div class="ciItem">
                    Directory
                    <span v-if="parent" class="liSpan">{{parent.name}}</span>
                    <span v-else>Unknown</span>
                  </div>
                  <div class="ciItem" v-if="['article', 'event', 'file'].includes(type)">
                    Header Image
                    <div class="sw sm" :class="{on: form.useHeaderImg.model === 1}"
                      v-on:click="form.useHeaderImg.model = form.useHeaderImg.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem hasDd">
                    Cover Style
                    <div v-bind:class="{dd: true, open: ddCoverStyle}"
                      v-on:click.stop="ddCoverStyle = !ddCoverStyle">
                      <template v-if="form.coverStyle.model === 'crop'">Croped</template>
                      <template v-else>Full Image</template>
                      <div class="ddMenu" v-if="ddCoverStyle">
                        <div class="ddSc">
                          <li v-on:click.stop="form.coverStyle.model = 'crop';
                            ddCoverStyle = false;">
                            <h4>Crop</h4>
                            <p>Will display croped image</p>
                          </li>
                          <li v-on:click.stop="form.coverStyle.model = 'full';
                            ddCoverStyle = false;">
                            <h4>Full</h4>
                            <p>Will display full image</p>
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div class="ciItem" v-if="['article', 'link', 'event', 'file'].includes(type)">
                    Display in Search
                    <div class="sw sm" :class="{on: form.enableSearch.model === 1}"
                      v-on:click="form.enableSearch.model = form.enableSearch.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem">
                    Enable Comment
                    <div class="sw sm" :class="{on: false}"
                      v-on:click="enableComment"></div>
                  </div>
                  <div class="ciItem">
                    <img src="../assets/private.png" style="opacity: .4;"
                      v-if="!form.isProtected.model">
                    <img src="../assets/private-green.png" v-else>
                    Protected Content
                    <div :class="{sw: 1, on: form.isProtected.model}"
                      v-on:click="form.isProtected.model = form.isProtected.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem" v-if="form.isProtected.model">
                    <img src="../assets/private.png" style="opacity: .4;"
                      v-if="form.password.model === ''">
                    <img src="../assets/private-green.png" v-else>
                    Password
                    <input type="text" placeholder="• • • • • • • •"
                      v-model="form.password.model">
                  </div>
                  <div class="ciItem">
                    Display Share
                    <div class="sw sm" :class="{on: form.displayShare.model === 1}"
                      v-on:click="form.displayShare.model = form.displayShare.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem">
                    Display Author
                    <div class="sw sm" :class="{on: form.displayAuthor.model === 1}"
                      v-on:click="form.displayAuthor.model = form.displayAuthor.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem">
                    Display Publish Date
                    <div class="sw sm" :class="{on: form.displayPublishDate.model === 1}"
                      v-on:click="form.displayPublishDate.model = form.displayPublishDate.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem">
                    Display Views
                    <div class="sw sm" :class="{on: form.displayViews.model === 1}"
                      v-on:click="form.displayViews.model = form.displayViews.model
                      === 1 ? 0 : 1"></div>
                  </div>
                  <div class="ciItem"
                    v-if="['article', 'gallery', 'video', 'audio', 'pdf', 'file'].includes(type)">
                    Custom Descriptions
                    <div class="sw sm" :class="{on: form.customDesc.model === 1}"
                      v-on:click="form.customDesc.model = form.customDesc.model
                      === 1 ? 0 : 1"></div>
                  </div>
                </div>
                <div class="configItem" v-if="form.customDesc.model === 1">
                  <h4>Short Descriptions</h4>
                  <textarea rows="3" class="field" v-model="form.description.model"
                    placeholder="Short descriptions..."></textarea>
                </div>
                <div class="configItem" v-if="type === 'event'">
                  <h4>Event date</h4>
                  <input type="datetime-local" class="field" v-model="form.eventDate.model">
                  <input type="datetime-local" class="field" v-model="form.eventDate2.model">
                </div>
                <div class="configItem" v-if="['link', 'event'].includes(type)">
                  <h4 v-if="type === 'link'">Link url</h4>
                  <h4 v-else-if="type === 'event'">Event Url</h4>
                  <input type="text" class="field" v-model="form.linkUrl.model"
                    placeholder="https://...">
                </div>
                <div class="configItem">
                  <h4>Keywords</h4>
                  <p>Add keywords in field below, separate by comma.</p>
                  <textarea rows="3" class="field" v-model="form.tags.model"
                    placeholder="Keywords..."></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="btnConfig metadata" v-if="!saving">
            <div class="theBtn" v-on:click.stop="metadataOpen = !metadataOpen;
              configOpen = false;"></div>
            <div class="configContent" v-if="metadataOpen" v-on:click.stop="metadataClicked">
              <div class="configItem">
                <h4>Metadata</h4>
                <div class="metadataCnt noData" v-if="metadata.length < 1">
                  <h4>No Metadata</h4>
                  <p>There is no metadata for this content</p>
                </div>
                <draggable v-model="metadata" class="metadataCnt"
                  handle=".metadataHandle" v-else>
                  <div class="metadataItem" v-for="(meta, i) in metadata" :key="`meta${i}`">
                    <div class="metadataHandle"></div>
                    <div class="label">
                      <div class="theLabel">{{meta.label[lang]}}</div>
                      <div class="more" v-on:click.stop="meta.more = !meta.more"></div>
                      <div class="moreMenu" v-if="meta.more">
                        <li v-on:click.stop="editMetadata(i, meta)">
                          Edit metadata</li>
                        <li class="red" v-on:click.stop="deleteMetadata(i, meta)">
                          Delete metadata</li>
                      </div>
                    </div>
                    <div class="metadataVal">{{meta.value[lang]}}</div>
                  </div>
                </draggable>
                <div class="btn btnAdd addMetadata" v-on:click.stop="addMetadata">
                  Add Metadata Item</div>
              </div>
            </div>
          </div>

          <div class="btnAttachment" v-if="!saving">
            <div class="theBtn" v-on:click="addAtt"></div>
          </div>
        </div>
      </div>
    </div>
    <MediaSelector ref="mediaSelector"/>
    <Confirmation ref="confirmDialog"/>
    <FormInputerShort ref="formInputer"/>
    <LoadingDialog ref="loadingDialog"/>
    <Snackbar ref="snackbar"/>
    <CategorySelector ref="categorySelector"/>
    <SectionSelector ref="sectionSelector"/>
    <GptSelector ref="gptSelector"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { nanoid } from 'nanoid';
import draggable from 'vuedraggable';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import MediaSelector from '@/components/MediaSelector.vue';
import Confirmation from '@/components/Confirmation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import Snackbar from '@/components/Snackbar.vue';
import Editor from '@/components/Editor.vue';
import CategorySelector from '@/components/CategorySelector.vue';
import SectionSelector from '@/components/SectionSelector.vue';
import SectionData from '@/components/SectionData.vue';
import GptSelector from '@/components/GptSelector.vue';

export default {
  name: 'editor',
  components: {
    draggable,
    MediaSelector,
    Confirmation,
    DatePicker,
    FormInputerShort,
    CategorySelector,
    LoadingDialog,
    Snackbar,
    Editor,
    SectionSelector,
    SectionData,
    GptSelector,
  },
  data() {
    return {
      type: 'article',
      ddType: false,
      media: null,
      getingData: true,
      notFound: false,
      parent: null,
      editData: null,
      titleMinHeight: 'auto',
      headerImg: null,
      btnDisabled: true,
      saving: false,
      pdfCover: null,
      attachments: [],
      showPdfOptions: false,
      videoPlaying: false,
      position: '',
      viewCount: 0,
      form: {
        title: { model: '', error: null },
        info: { model: '', error: null },
        content: { model: '', content: '' },
        tags: { model: '' },
        isProtected: { model: 0 },
        password: { model: '' },
        eventDate: { model: '' },
        eventDate2: { model: '' },
        linkUrl: { model: '' },
        useHeaderImg: { model: 1 },
        customDesc: { model: 0 },
        description: { model: '' },
        displayPublishDate: { model: 1 },
        displayViews: { model: 1 },
        displayAuthor: { model: 1 },
        displayShare: { model: 1 },
        enableSearch: { model: 1 },
        coverStyle: { model: 'crop' },
      },

      /**
       * Cover style
       *
       */
      ddCoverStyle: false,

      /**
       * Store form data
       *
       */
      formData: null,

      /**
       * Config
       *
       */
      configOpen: false,

      /**
       * Metadata
       *
       */
      metadataOpen: false,
      metadata: [],

      /**
       * Section
       *
       */
      sectionData: [],

      /**
       * Language
       *
       */
      openLangSelector: false,
      lang: 'id',

      /**
       * Publish time
       *
       */
      pt: new Date(),
      openDateSelector: false,

      /**
       * Author
       *
       */
      selectedAuthor: null,
      authors: [],
      ddOpenAuthor: false,

      /**
       * Category
       *
       */
      category: [],

      /**
       * New publish button
       *
       */
      showMoreOptions: false,

      /**
       * Gallery
       *
       */
      galleryIdx: null,
      showImgMore: null,
      gallery: [],

      /**
       * AI / ChatGPT
       *
       */
      loadingGPT: false,
      gptResultOpen: false,
      gptResult: '',
      gptType: '',
    };
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),
    enableComment() {
      const desc = 'You need to add User Authentication extensions to enable article comment, '
        + 'so only logged in user are able to comment to prevent spam. Please contact developer '
        + 'to add User Authentication System.';
      this.$refs.confirmDialog.open({
        title: 'Missing Extensions',
        desc,
        error: true,
      });
    },
    sectionChanged(sectionData) {
      // this.pSelected.sectionData = sectionData;
      // this.savePage('draft');
    },
    sectionClicked() {
      this.showImgMore = false;
      this.ddOpenAuthor = false;
      this.metadataOpen = false;
      this.configOpen = false;
      this.ddCoverStyle = false;
    },
    configCntClicked() {
      this.ddCoverStyle = false;
      this.ddType = false;
      this.ddOpenAuthor = false;
    },
    doNothing() {},
    playPauseAudio() {
      if (!this.media) {
        this.addPdf();
        return;
      }
      if (this.$refs.audio.paused) this.$refs.audio.play();
      else this.$refs.audio.pause();
    },
    selectAuthor(author) {
      this.selectedAuthor = author;
      this.ddOpenAuthor = false;
    },
    openAiDialog() {
      if (this.loadingGPT) return;
      this.$refs.gptSelector.open(null, (b, c) => {
        if (!b) return;
        this.gptType = c;
        if (c === 'create') this.fillWithGPT();
        else this.analyzeGpt();
      });
    },
    async analyzeGpt() {
      const content = this.form.content.model.replace(/<br ?\/?>/gm, '\n\n').replace(/<[^>]*>?/gm, '').trim();
      if (!content) {
        this.$refs.confirmDialog.open({
          title: 'Content is empty',
          desc: 'Please fill article\'s content first before generating with AI',
          error: true,
        });
        return;
      }

      if (this.loadingGPT) return;
      this.loadingGPT = true;
      this.gptResult = '';
      await this.$http.post(this.$config.uri(`article/gpt/${this.gptType}`), { content }, {
        responseType: 'text',
        onDownloadProgress: (ev) => {
          const e = ev.event || ev;
          if (e.target.response && !this.gptResultOpen) this.gptResultOpen = true;
          let parsedText = e.target.response;
          parsedText = parsedText.replace('Sentiment:', '<b>Sentiment</b><br />');
          parsedText = parsedText.replace('Key Point:', '<b>Key Point</b><br />');
          parsedText = parsedText.replace('Insightful Report:', '<b>Insightful Report</b><br />');
          parsedText = parsedText.replace('Tags:', '<b>Tags</b><br />');
          this.gptResult = parsedText;
        },
      });
      this.loadingGPT = false;
      if (!this.gptResult || this.gptResult === '') {
        this.$refs.confirmDialog.open({
          title: 'Generate AI Failed',
          desc: 'Im so sorry i can\t analyze this article cotnent at the moment',
          error: true,
        });
      }
    },
    fillWithGPT() {
      if (!this.form.title.model) {
        this.$refs.confirmDialog.open({
          title: 'Title is empty',
          desc: 'Please fill article\'s title first before generating article with AI',
          error: true,
        });
        return;
      }
      this.doFillWithGPT();
    },
    async doFillWithGPT() {
      if (this.loadingGPT) return;
      this.loadingGPT = true;
      this.gptResult = '';
      await this.$http.post(this.$config.uri('article/gpt/create'), {
        title: this.form.title.model,
      }, {
        responseType: 'text',
        onDownloadProgress: (ev) => {
          const e = ev.event || ev;
          if (e.target.response && !this.gptResultOpen) this.gptResultOpen = true;
          this.gptResult = e.target.response;
        },
      });
      this.loadingGPT = false;
      if (!this.gptResult || this.gptResult === '') {
        this.$refs.confirmDialog.open({
          title: 'Fill article with AI failed',
          desc: 'Im so sorry i can\t find the best article for your right now. maybe try changing article\'s title will help',
          error: true,
        });
      }
    },
    applyToArticle() {
      const content = this.form.content.model.replace(/<[^>]*>?/gm, '').trim();
      if (content) {
        this.$refs.confirmDialog.open({
          title: 'Apply to Article Content',
          desc: 'This will replace the existing content with generated text, are you sure you want to continue?',
          action: 'Apply',
        }, (b) => {
          if (!b) return;
          this.doApplyToArticle();
        });
      } else {
        this.doApplyToArticle();
      }
    },
    doApplyToArticle() {
      this.gptResultOpen = false;
      this.form.content.model = this.gptResult;
      this.form.content.content = 'Write something great...';
      setTimeout(() => {
        this.form.content.content = this.gptResult;
        this.$refs.editor.focus();
        setTimeout(() => {
          this.$refs.editor.blur();
        });
      });
    },
    editAtt(i, item) {
      this.$refs.mediaSelector.open(null, (b, m) => {
        if (!b) return;
        const media = (m.gallery) ? m.gallery[0] : m;
        this.attachments[i] = media;
        const attTmp = this.attachments;
        this.attachments = [];
        setTimeout(() => {
          this.attachments = attTmp;
        });
      });
    },
    addAtt() {
      if (this.type === 'link') {
        this.$refs.confirmDialog.open({
          title: 'Can Not Attach To Link',
          desc: 'Can not attach any file to content type link, because user will leave the page when content clicked',
          error: true,
        });
        return; // eslint-disable-line
      }
      this.$refs.mediaSelector.open(null, (b, m) => {
        if (!b) return;
        const selectedMedia = (m.gallery) ? m.gallery : [m];
        const atts = [];
        // eslint-disable-next-line
        for (const media of selectedMedia) {
          if (media.type === 'video' && media.mimetype === 'video/youtube') {
            this.$refs.confirmDialog.open({
              title: 'Media Not Supported',
              desc: 'Can not attach youtube video, only file can be attachment to content',
              error: true,
            });
            continue; // eslint-disable-line
          }
          atts.push(media);
        }
        this.attachments.push(...atts);
      });
    },
    changeCategory() {
      if (!this.parent) return;
      this.$refs.categorySelector.open({
        directory: this.parent,
        categories: this.category,
      }, (b, c) => {
        if (!b) return;
        this.category = c;
      });
    },
    editGallery(i, item) {
      this.showPrizeMore = null;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.gallery[i].id = media.id;
        this.gallery[i].imageBl = media.imageBl;
        this.gallery[i].imageTh = media.imageTh;
        this.gallery[i].imageSm = media.imageSm;
        this.gallery[i].imageMd = media.imageMd;
        this.gallery[i].imageLg = media.imageLg;
      });
    },
    deleteGallery(i, item) {
      this.showPrizeMore = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Image',
        desc: 'Are you sure you want to delete this image from gallery?',
      }, (b) => {
        if (!b) return;
        this.gallery.splice(i, 1);
      });
    },
    deleteAtt(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Attachment',
        desc: 'Are you sure you want to delete this attachment item?',
      }, (b) => {
        if (!b) return;
        this.attachments.splice(i, 1);
      });
    },
    addHeaderImg() {
      this.showPdfOptions = false;
      this.showPrizeMore = null;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b || media.processing) return;
        if (this.type === 'gallery') {
          const gallery = (media.gallery) ? media.gallery : [media];
          this.gallery.push(...gallery);
        } else {
          this.headerImg = (media.gallery) ? media.gallery[0] : media;
        }
      });
    },
    addPdf() {
      this.showPdfOptions = false;
      this.showPrizeMore = null;
      let { type } = this;
      if (['gallery', 'article', 'link', 'profile'].includes(type)) type = 'image';
      if (type === 'file') type = 'all';
      this.$refs.mediaSelector.open({ type }, (b, media) => {
        if (!b || media.processing) return;
        if (['video', 'pdf', 'audio', 'file'].includes(this.type)) {
          this.media = null;
          setTimeout(() => {
            this.media = (media.gallery) ? media.gallery[0] : media;
          });
        } else if (this.type === 'gallery') {
          const gallery = (media.gallery) ? media.gallery : [media];
          this.gallery.push(...gallery);
        } else {
          this.headerImg = (media.gallery) ? media.gallery[0] : media;
        }
      });
    },
    customCover() {
      this.showPdfOptions = false;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (b) this.pdfCover = media;
      });
    },
    resetCover() {
      this.showPdfOptions = false;
      this.pdfCover = null;
    },
    titleChanged() {
      this.form.title.error = null;
      this.$refs.title.style.height = '5px';
      this.$refs.title.style.height = `${this.$refs.title.scrollHeight}px`;
      this.btnDisabled = (!this.form.title.model || this.form.title.model.trim() === '');
    },
    preview() {
      this.showMoreOptions = false;
      this.doSave('draft', (r) => {
        window.open(`${this.$config.frontEnd}berita/preview/${r.data.id}?_sign=${r.data.sign}`);
      });
    },
    doSave(status, next) {
      if (this.saving || this.btnDisabled) return;
      this.genFormData();
      this.formData.status = status;
      this.formData.publishDate = Math.floor(this.pt.getTime() / 1000);
      this.formData.categories = this.category;
      this.formData.parentId = this.parent.id;
      this.formData.type = this.type;
      this.formData.authorId = (this.selectedAuthor) ? this.selectedAuthor.id : null;
      this.formData.eventDate = this.form.eventDate.model;
      this.formData.eventDate2 = this.form.eventDate2.model;
      this.formData.linkUrl = this.form.linkUrl.model;
      this.formData.customDesc = this.form.customDesc.model;
      this.formData.useHeaderImg = this.form.useHeaderImg.model;
      this.formData.displayPublishDate = this.form.displayPublishDate.model;
      this.formData.displayViews = this.form.displayViews.model;
      this.formData.displayAuthor = this.form.displayAuthor.model;
      this.formData.displayShare = this.form.displayShare.model;
      this.formData.enableSearch = this.form.enableSearch.model;
      this.formData.isProtected = this.form.isProtected.model;
      this.formData.password = this.form.password.model;
      this.formData.sectionData = this.sectionData;
      this.formData.metadata = this.metadata;
      this.formData.coverStyle = this.form.coverStyle.model;
      if (this.editData && this.editData.id) this.formData.id = this.editData.id;
      this.saveNow(next);
    },
    saveNow(next) {
      this.saving = true;
      this.$http.post(this.$config.uri('article/save'), this.formData).then((r) => {
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.saving = false;
        const status = (this.formData.status === 'draft') ? 'unpublished' : 'published';
        if (next) next(r.data);
        else this.$router.push(`/content/${this.parent.code}?tab=${status}&dirId=${parseInt(this.$route.query.dirId, 10)}`);
      });
    },
    getData() {
      const { id } = this.$route.query;
      const { parent } = this.$route.params;
      this.$http.get(this.$config.uri('user/all?role=admin')).then((ru) => {
        this.authors = (ru.data.status === 200) ? ru.data.data : [];
        if (id) {
          this.getingData = true;
          const detailUri = `article/all/admin?parent=${parent}&id=${id}`;
          this.$http.get(this.$config.uri(detailUri)).then((response) => {
            this.getingData = false;
            if (response.data.status !== 200) {
              // Display error
              this.notFound = true;
              return;
            }
            this.editData = response.data.data;
            this.selectedAuthor = this.editData.author;
            this.type = this.editData.type;
            this.media = (this.editData.media) ? this.editData.media[this.lang] : null;
            this.gallery = (this.editData.gallery[this.lang])
              ? this.editData.gallery[this.lang] : [];
            this.headerImg = (this.editData.headerImg) ? this.editData.headerImg[this.lang] : null;
            this.form.title.model = this.editData.title[this.lang];
            this.form.tags.model = this.editData.tags[this.lang];
            this.form.description.model = this.editData.description[this.lang];
            this.form.info.model = this.editData.additionalInfo[this.lang];
            this.form.useHeaderImg.model = this.editData.useHeaderImg;
            this.form.displayPublishDate.model = this.editData.displayPublishDate;
            this.form.displayViews.model = this.editData.displayViews;
            this.form.displayShare.model = this.editData.displayShare;
            this.form.displayAuthor.model = this.editData.displayAuthor;
            this.form.enableSearch.model = this.editData.enableSearch;
            this.form.isProtected.model = this.editData.isProtected;
            this.form.password.model = this.editData.password;
            this.form.customDesc.model = this.editData.customDesc;
            this.form.coverStyle.model = this.editData.coverStyle || 'crop';

            this.form.eventDate.model = (this.editData.eventDate
              && this.editData.eventDate !== '')
              ? this.editData.eventDate.split('.')[0].replace('T', ' ')
              : '';
            this.form.eventDate2.model = (this.editData.eventDate2
              && this.editData.eventDate2 !== '')
              ? this.editData.eventDate2.split('.')[0].replace('T', ' ')
              : '';
            this.form.linkUrl.model = this.editData.linkUrl;
            this.form.content.model = this.editData.content[this.lang];
            this.pt = new Date(this.editData.publishDate * 1000);
            this.attachments = this.editData.attachments[this.lang] || [];
            this.category = this.editData.categories || [];
            setTimeout(() => {
              this.titleChanged();
              this.form.content.content = this.editData.content[this.lang];
            });
            this.pdfCover = (this.editData.cover) ? this.editData.cover[this.lang] || null : null;
            this.sectionData = this.editData.sectionData || [];
            this.metadata = this.editData.metadata || [];
            if (this.type === 'profile') this.findPosition();

            this.formData = {
              title: { en: '', id: '' },
              info: { en: '', id: '' },
              tags: { en: '', id: '' },
              content: { en: '', id: '' },
              description: { en: '', id: '' },
              attachments: { en: [], id: [] },
              gallery: { en: [], id: [] },
              headerMedia: { en: null, id: null },
              media: { en: null, id: null },
              cover: { en: null, id: null },
            };

            this.formData.title.en = this.editData.title.en;
            this.formData.title.id = this.editData.title.id;
            this.formData.info.en = this.editData.additionalInfo.en;
            this.formData.info.id = this.editData.additionalInfo.id;
            this.formData.tags.en = this.editData.tags.en;
            this.formData.tags.id = this.editData.tags.id;
            this.formData.content.en = this.editData.content.en;
            this.formData.content.id = this.editData.content.id;
            this.formData.description.en = this.editData.description.en;
            this.formData.description.id = this.editData.description.id;

            if (this.editData.gallery) {
              this.formData.gallery.id = this.editData.gallery.id;
              this.formData.gallery.en = this.editData.gallery.en;
            }

            if (this.editData.headerImg) {
              this.formData.headerMedia.id = this.editData.headerImg.id;
              this.formData.headerMedia.en = this.editData.headerImg.en;
            }

            if (this.editData.media) {
              this.formData.media.id = this.editData.media.id;
              this.formData.media.en = this.editData.media.en;
            }

            if (this.editData.cover) {
              this.formData.cover.id = this.editData.cover.id;
              this.formData.cover.en = this.editData.cover.en;
            }

            if (this.editData.attachments) {
              this.formData.attachments.id = this.editData.attachments.id;
              this.formData.attachments.en = this.editData.attachments.en;
            }
          });
        } else {
          // eslint-disable-next-line
          for (const user of this.authors) {
            if (user.email === this.$session.get('email')) {
              this.selectedAuthor = user;
              break;
            }
          }
          this.type = this.$route.query.type || 'article';
          if (['video', 'pdf', 'audio', 'file'].includes(this.type)) {
            const { mid } = this.$route.query;
            this.$http.get(this.$config.uri(`media/detail/${mid}`)).then((r) => {
              this.media = (r.data.status === 200) ? r.data.data : null;
              this.getingData = false;
            });
          } else if (this.type === 'gallery') {
            const { mids } = this.$route.query;
            this.$http.get(this.$config.uri(`media/all?ids=${mids}`)).then((r) => {
              this.gallery = (r.data.status === 200) ? r.data.data : [];
              this.getingData = false;
            });
          } else {
            this.form.linkUrl.model = this.$route.query.uri || '';
            this.form.eventDate.model = this.$route.query.d1 || '';
            this.form.eventDate2.model = this.$route.query.d2 || '';
            this.getingData = false;
          }


          /**
           * Auto fill metadata
           *
           */
          if (this.type === 'profile') {
            this.metadata.push({
              label: { id: 'Jabatan Anggota', en: 'Member\'s Position' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Email Anggota', en: 'Member\'s Email' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Google Scholar Anggota', en: 'Member Google\'s Scholar' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'LinkedIn Anggota', en: 'Member\'s LinkedIn' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Alamat Anggota', en: 'Member\'s Address' },
              value: { id: '', en: '' },
              more: false,
            });
          } else if (this.type === 'event') {
            this.metadata.push({
              label: { id: 'Lokasi', en: 'Location' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Penyelenggara', en: 'Organizer' },
              value: { id: '', en: '' },
              more: false,
            });
          } else if (this.type === 'pdf') {
            this.metadata.push({
              label: { id: 'ISBN', en: 'ISBN' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Penerbit', en: 'Publisher' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Tahun Terbit', en: 'Publish Date' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Penulis', en: 'Writer' },
              value: { id: '', en: '' },
              more: false,
            });
            this.metadata.push({
              label: { id: 'Editor', en: 'Editor' },
              value: { id: '', en: '' },
              more: false,
            });
          }
        }
      });
    },
    openMoreOptions() {
      if (this.btnDisabled) return;
      this.showMoreOptions = !this.showMoreOptions;
    },

    /**
     * Section
     *
     */
    addSection() {
      this.$refs.sectionSelector.open((b, o) => {
        if (!b) return;
        const section = {
          id: nanoid(),
          title: '',
          descriptions: '',
          color: '',
          type: o,
          items: [],
          config: {},
          collapsed: false,
          status: 'published',
        };
        if (o === 'Gallery') {
          /**
           * Gallery are fixed 12 item
           *
           */
          for (let i = 0; i < 12; i += 1) {
            section.items.push({});
          }
        } else if (o === 'Block Articles') {
          section.config.itemPerPage = 4;
          section.config.articleCount = 8;
          section.config.displayViewAll = false;
          section.config.sources = 'Auto Selections';
          section.config.displayType = 'Slider';
          section.config.viewAllLabel = { en: 'View All', id: 'Lihat Semua' };
          section.config.viewAllUrl = { en: '', id: '' };
          section.config.directory = null;
        } else if (o === 'Map') {
          section.config.mapboxStyle = 'mapbox://styles/mapbox/streets-v12';
          section.config.lat = -2.997868;
          section.config.lng = 118.683471;
          section.config.zoom = 7;
          section.config.showControl = true;
          section.config.interactive = true;
          section.config.wideScreen = true;
          section.config.fullScreen = true;
          section.config.attribution = false;
          section.config.attributionLabel = { id: '', en: '' };
          section.config.geojson = null;
        } else if (o === 'Custom Block') {
          section.config.code = null;
        } else if (o === 'Form') {
          section.config.thankYouTitle = { id: '', en: '' };
          section.config.thankYouDesc = { id: '', en: '' };
          section.config.emailVerification = true;
        } else if (o === 'Subscription') {
          section.config.thankYouTitle = { id: '', en: '' };
          section.config.thankYouDesc = { id: '', en: '' };
          section.config.emailVerification = true;
        } else if (o === 'Slider') {
          section.config.fullScreen = true;
        }
        this.sectionData.push(section);
      });
    },

    /**
     * Metadata
     *
     */
    metadataClicked() {
      // eslint-disable-next-line
      for (const item of this.metadata) {
        item.more = false;
      }
    },
    addMetadata() {
      this.$refs.confirmDialog.open({
        title: 'Add Metadata Item',
        desc: 'Fill metadata information below',
        multiLang: true,
        action: 'Add Item',
        inputs: [
          {
            label: 'Label',
            placeholder: 'Metadata label...',
            type: 'text',
            value: { en: '', id: '' },
          },
          {
            label: 'Metadata',
            placeholder: 'Metadata information...',
            type: 'longtext',
            value: { en: '', id: '' },
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        this.metadata.push({
          label: v[0].value,
          value: v[1].value,
          more: false,
        });
        if (this.type === 'profile') this.findPosition();
      });
    },
    editMetadata(i, item) {
      item.more = false; // eslint-disable-line
      const itemEdit = JSON.parse(JSON.stringify(item));
      this.$refs.confirmDialog.open({
        title: 'Add Metadata Item',
        desc: 'Fill metadata information below',
        multiLang: true,
        action: 'Set Item',
        inputs: [
          {
            label: 'Label',
            placeholder: 'Metadata label...',
            type: 'text',
            value: itemEdit.label,
          },
          {
            label: 'Metadata',
            placeholder: 'Metadata information...',
            type: 'longtext',
            value: itemEdit.value,
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        item.label = v[0].value; // eslint-disable-line
        item.value = v[1].value; // eslint-disable-line
        if (this.type === 'profile') this.findPosition();
      });
    },
    deleteMetadata(i, item) {
      item.more = false; // eslint-disable-line
      this.$refs.confirmDialog.open({
        title: 'Delete Metadata item',
        desc: `Are you sure you want to delete ${item.label} metadata item?`,
      }, (b) => {
        if (!b) return;
        this.metadata.splice(i, 1);
        if (this.type === 'profile') this.findPosition();
      });
    },
    findPosition() {
      // eslint-disable-next-line
      for (const meta of this.metadata) {
        if ((meta.label.id.toLowerCase().indexOf('posisi') >= 0
          || meta.label.id.toLowerCase().indexOf('position') >= 0
          || meta.label.en.toLowerCase().indexOf('posisi') >= 0
          || meta.label.en.toLowerCase().indexOf('position') >= 0)
          && (meta.value.id || meta.value.en)) {
          this.position = meta.value[this.lang];
        }
      }
    },

    /**
     * Language
     *
     */
    genFormData() {
      if (!this.formData) {
        this.formData = {
          title: { en: '', id: '' },
          info: { en: '', id: '' },
          tags: { en: '', id: '' },
          content: { en: '', id: '' },
          description: { en: '', id: '' },
          attachments: { en: [], id: [] },
          gallery: { en: [], id: [] },
          headerMedia: { en: null, id: null },
          media: { en: null, id: null },
          cover: { en: null, id: null },
        };
      }
      this.formData.title[this.lang] = this.form.title.model;
      this.formData.info[this.lang] = this.form.info.model;
      this.formData.tags[this.lang] = this.form.tags.model;
      this.formData.content[this.lang] = this.form.content.model;
      this.formData.description[this.lang] = this.form.description.model;
      this.formData.headerMedia[this.lang] = this.headerImg;
      this.formData.attachments[this.lang] = this.attachments;
      this.formData.media[this.lang] = this.media;
      this.formData.cover[this.lang] = this.pdfCover;
      this.formData.gallery[this.lang] = this.gallery;
    },
    selectLang(lang) {
      this.openLangSelector = false;
      if (this.lang === lang) return;
      this.genFormData();
      this.lang = lang;

      this.form.title.model = this.formData.title[lang];
      this.form.info.model = this.formData.info[lang];
      this.form.tags.model = this.formData.tags[lang];
      this.form.description.model = this.formData.description[lang];

      this.headerImg = this.formData.headerMedia[lang];
      this.attachments = this.formData.attachments[lang];
      this.pdfCover = this.formData.cover[lang];
      this.media = null;
      this.gallery = this.formData.gallery[lang];

      this.form.content.model = this.formData.content[lang];
      this.form.content.content = 'Write something great...';
      setTimeout(() => {
        this.titleChanged();
        this.media = this.formData.media[lang];
        this.form.content.content = this.formData.content[lang];
        this.$refs.editor.focus();
        setTimeout(() => {
          this.$refs.editor.blur();
        });
      });
    },
  },
  mounted() {
    this.chCGB(false);
    this.chDirId(parseInt(this.$route.query.dirId, 10));
    const { parent } = this.$route.params;
    this.getData();
    this.$http.get(this.$config.uri(`article/directory/${parent}`)).then((r) => {
      this.parent = r.data.data;
      this.form.displayShare.model = this.parent.displayShare;
      this.form.displayAuthor.model = this.parent.displayAuthor;
      this.form.displayPublishDate.model = this.parent.displayPublishDate;
      this.form.displayViews.model = this.parent.displayViews;
      this.form.enableSearch.model = this.parent.enableSearch;
      this.chTitle(`Content - ${this.parent.name}`);
    });
  },
};
</script>

<style scoped lang="scss">
#editorPage.content{
  height: calc(100vh - 104px);
}
.getingData{
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url(../assets/loading-2.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 46px auto;
}
.notFound{
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  img{
    height: 340px;
    margin-bottom: 40px;
  }
  h4{
    font-size: 30px;
    font-weight: normal;
    margin: 0 0 10px;
  }
  p{
    max-width: 600px;
    color: #767676;
    font-size: 17px;
  }
}
.thePdf.forAudio{
  border-radius: 5px;
  overflow: hidden;
  border: #eee 1px solid;
  position: relative;
  margin-bottom: 10px;
  cursor: pointer;
  .audioAlbum{
    height: 266px;
    background-color: #d9d6e4;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    &.full{
      background-size: contain;
    }
    &.noImg{
      background-image: url(../assets/musical-note.svg);
      background-size: 46px auto;
    }
  }
  audio{
    display: block;
    width: 100%;
    border-radius: 0;
    background-color: #f5f5f5;
  }
}
.headerImg{
  height: 320px;
  background-color: #ddd;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all .3s ease;
  position: relative;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
  &.pdf{
    width: 300px;
    height: 400px;
    img{
      display: block;
    }
    .pdfCover.crop{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      border-radius: 5px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  &.full{
    min-height: 160px;
    height: auto;
    background-image: none !important;
    img{
      width: 100%;
      display: block;
    }
  }
  &.profile{
    width: 300px;
    height: 300px;
    border-radius: 50%;
  }
  &.full2{
    background-size: contain;
    .coverImg{
      background-color: #222;
      background-size: contain;
    }
  }
  &.video{
    background-color: #222;
  }
  &.noImg{
    background-size: 46px auto;
    background-image: url(../assets/photo-black.png);
    opacity: .3;
    &.video{
      background-color: #ddd;
      background-image: url(../assets/video-black.png);
    }
    &:hover{
      opacity: .46;
    }
  }
  video{
    height: 100%; width: 100%;
  }
  .coverImg{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 3;
    .playBtn{
      width: 54px; height: 54px;
      background-image: url(../assets/play.png);
      background-size: 26px auto;
      box-sizing: border-box;
      background-position: 12px 50%;
      background-repeat: no-repeat;
      position: absolute;
      left: 50%; top: 50%;
      margin: -27px 0 0 -27px;
      transition: all .3s ease;
      border: #fff 3px solid;
      border-radius: 50%;
      opacity: .76;
    }
    &:hover{
      .playBtn{
        opacity: 1;
      }
    }
  }
}
iframe{
  width: 100%; height: 100%;
}
.pdfOption{
  position: absolute;
  right: 10px; top: 10px;
  z-index: 9;
  cursor: pointer;
  .optBtn{
    width: 34px; height: 34px;
    background-color: #fff;
    border-radius: 50%;
    position: relative;
    box-shadow: 2px 2px 4px rgba(0,0,0,.1);
    &:hover{
      background-color: #f5f5fe;
    }
    &:before{
      position: absolute;
      content: "";
      left: 0; right: 0; top: 0; bottom: 0;
      background-image: url(../assets/more.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .optOverlay{
    position: fixed;
    left: 0; top: 0; right: 0; bottom: 0;
    cursor: default;
    z-index: 1;
  }
  .optCnt{
    position: absolute;
    right: 0; top: 100%;
    background-color: #fff;
    box-shadow: 2px 2px 4px rgba(0,0,0,.2);
    border-radius: 5px;
    padding: 10px 0;
    z-index: 2;
    li{
      list-style: none;
      padding: 6px 20px;
      cursor: pointer;
      font-size: 15px;
      white-space: nowrap;
      &.divider{
        background-color: #eee !important;
        height: 1px;
        padding: 0;
        margin: 5px 0;
      }
      &.red{
        color: red;
      }
      &:hover{
        background-color: #f5f5fe;
      }
    }
  }
}

.articleCnt{
  max-width: 840px;
  margin: 0 auto;
  padding: 20px 0 40px;
  // padding-right: 30px;
  box-sizing: border-box;
  min-height: 400px;
  // position: relative;
  // z-index: 3;
  // width: calc(100% - 300px);
  .articleTitle{
    width: 100%;
    box-sizing: border-box;
    border: none;
    padding: 10px 0;
    outline: 0;
    font-size: 40px;
    font-weight: bold;
    resize: none;
  }
  .fieldGroup.userInfo{
    position: static;
    font-size: 22px;
    color: #767676;
    .field{
      position: static;
      padding-left: 0;
      padding-right: 0;
      border: none;
      border: none;
      box-shadow: none;
    }
  }
  .titleError{
    color: red;
    border-top: red 3px solid;
    margin: -4px 0 16px;
  }
}

.thumbImgCnt{
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  margin-bottom: -6px;
  .thumbImg{
    width: 60px; height: 60px;
    border-radius: 50px;
    border: #fff 3px solid;
    background-size: cover;
    transition: all .16s ease;
    margin: 0 10px 6px -3px;
    cursor: pointer;
    &:hover{
      border-color: #999;
    }
    &.selected{
      border-color: #0057d8;
    }
  }
}

.sectionCnt{
  margin-top: 20px;
  padding-top: 20px;
  .sTitle{
    font-size: 20px;
    margin: 0 7px 10px;
  }
}

.attachmentCnt{
  padding-top: 20px;
  margin-top: 20px;
  .aTitle{
    font-size: 20px;
    margin: 0 7px 10px;
  }
  .attachmentItem{
    position: relative;
    padding: 6px 10px;
    padding-right: 120px;
    background-color: #fff;
    border-radius: 5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    border: #eee 1px solid;
    // box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    .attachmentIcon{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px; height: 26px;
      border-radius: 3px;
      background-color: #d9d6e4;
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/attachment.png);
      font-size: 13px;
      color: #fff;
      font-weight: 600;
      text-transform: uppercase;
      margin-right: 10px;
      &.pdf{
        background-color: #e21717;
        background-image: url(../assets/pdf-icon-white.png);
      }
      &.audio{
        background-image: url(../assets/musical-note-blue.svg);
      }
      &.image{
        background-size: cover;
      }
      &.video{
        background-size: cover;
      }
      &.add{
        background-image: url(../assets/plus-circle.png);
        background-color: transparent;
        background-size: 20px auto;
      }
    }
    .aIcon{
      position: absolute;
      width: 30px; height: 30px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 12px auto;
      background-image: url(../assets/close.png);
      border-radius: 50%;
      top: 50%; right: 10px;
      margin-top: -15px;
      transition: background-color .3s ease;
      cursor: pointer;
      opacity: .45;
      &:hover{
        background-color: #eee;
      }
      &.download{
        right: 82px;
        background-image: url(../assets/download-o.png);
        background-size: 14px auto;
        opacity: 1;
      }
      &.edit{
        right: 46px;
        background-image: url(../assets/edit-black.png);
        background-size: 14px auto;
        opacity: 1;
      }
    }
    h4{
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 40px);
    }
    p{
      margin: 0;
      color: #767676;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.uploading{
      .attachmentIcon{
        background-color: #ddd;
        color: #eee;
        &:before{
          position: absolute;
          content: "";
          left: 0; top: 0; right: 0; bottom: 0;
          background-image: url(../assets/loading-2.svg);
          background-size: 24px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
  }
  &.fileDownload{
    margin: 0;
    .attachmentItem{
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #f5f5fe;
      }
    }
  }
}

.authorInfo{
  position: relative;
  padding-top: 8px;
  padding-left: 50px;
  padding-bottom: 16px;
  &.noAuthor{
    padding-left: 0;
    padding-top: 0;
  }
  .authorImg{
    position: absolute;
    left: 0;
    top: 8px;
    width: 39px;
    height: 39px;
    background-color: #ec174c;
    // background-image: url(../assets/user.png);
    background-size: cover;
    background-position: center;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-transform: uppercase;
    line-height: 0;
    &.hasPhoto{
      span{
        display: none;
      }
    }
  }
  h4{
    margin: 0;
    font-size: 17px;
    color: #444;
    font-weight: 600;
  }
  .publishTime{
    margin: 0;
    font-size: 14px;
    color: #767676;
    display: flex;
    align-items: center;
    span{
      position: relative;
      &.bull{
        margin: 0 10px;
      }
      &.label{
        padding-left: 20px;
        color: #767676;
        display: block;
        position: relative;
        font-weight: 600;
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; bottom: 0; width: 14px;
          background-size: 14px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .56;
        }
        &.type{
          &.gallery:before{
            background-image: url(../assets/image-black.png);
          }
          &.profile:before{
            background-image: url(../assets/account.png);
          }
          &.article:before{
            background-image: url(../assets/listing-black.png);
          }
          &.event:before{
            background-image: url(../assets/calendar.png);
          }
          &.video:before{
            background-image: url(../assets/video-black.png);
          }
          &.audio:before{
            background-image: url(../assets/musical-note.svg);
          }
          &.pdf:before{
            background-image: url(../assets/type-pdf.png);
          }
          &.file:before{
            background-image: url(../assets/file-download.png);
          }
          &.link:before{
            background-image: url(../assets/link-icon.png);
          }
        }
      }
    }
  }
}

.formAction{
  position: fixed;
  bottom: 0; right: 0;
  background-color: #fff;
  border-top: #ddd 1px solid;
  padding: 7px 0;
  text-align: right;
  z-index: 4;
  .formActionCnt{
    position: relative;
    margin: 0 20px;
    @media (min-width: 1600px) {
      margin: 0 auto;
      max-width: 1200px;
    }
    .categoryCnt{
      float: left;
      margin-right: 5px;
      position: relative;
      .configOverlay{
        position: fixed;
        left: 0; right: 0; bottom: 0; top: 0;
        z-index: 8;
      }
      .configContent{
        position: absolute;
        bottom: 100%;
        width: 240px;
        padding: 20px;
        padding-bottom: 0;
        right: -80px;
        margin-bottom: 10px;
        box-shadow: 1px 1px 2px rgba(0,0,0,.1);
        background-color: #fff;
        text-align: left;
        border: #ccc 1px solid;
        z-index: 9;
        border-radius: 7px;
        &.datePicker{
          padding: 0;
          border: none;
          width: 252px;
        }
        &:before{
          position: absolute;
          content: "";
          left: 50%;
          bottom: -10px;
          margin-left: 16px;
          border-top: #ccc 10px solid;
          border-left: transparent 10px solid;
          border-right: transparent 10px solid;
        }
        &:after{
          position: absolute;
          content: "";
          left: 50%;
          bottom: -8px;
          margin-left: 17px;
          border-top: #fff 9px solid;
          border-left: transparent 9px solid;
          border-right: transparent 9px solid;
        }
        .configItemSc{
          max-height: 300px;
          margin: 0 -20px;
          padding: 0 20px;
          border-top: #eee 1px solid;
          border-bottom: #eee 1px solid;
        }
        .configItem{
          margin-bottom: 16px;
          h4{
            margin: 0;
            margin-bottom: 5px;
            font-size: 18px;
            font-weight: 600;
          }
          .ciItem{
            // font-size: 18px;
            margin: 0 -20px;
            padding: 8px 20px;
            cursor: pointer;
            color: #444;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            // font-weight: bold;
            position: relative;
            padding-right: 64px;
            &.addCategory{
              color: #767676;
            }
            &.category{
              padding-left: 46px;
              .checkbox{
                width: 13px; height: 13px;
                border: #999 2px solid;
                border-radius: 3px;
                position: absolute;
                left: 20px; top: 9px;
                transition: all .3s ease;
                &.checked{
                  background-color: #ec174c;
                  border-color: #ec174c !important;
                  background-image: url(../assets/tick-white.png);
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                }
              }
              &:hover{
                .checkbox{
                  border-color: #222;
                }
              }
            }
            .msgIconCnt{
              position: absolute;
              right: 10px; top: 6px;
            }
            .msgIcon{
              width: 16px; height: 16px;
              display: inline-block;
              margin-right: 6px;
              margin-top: 6px;
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              &.wa{
                background-image: url(../assets/i-wa.png);
              }
              &.sms{
                background-image: url(../assets/sms.png);
              }
              &.delete{
                background-image: url(../assets/close.png);
                background-size: 10px;
                width: 26px; height: 26px;
                border-radius: 50%;
                margin-top: -2px;
                transition: all .3s ease;
                margin-right: 2px;
                opacity: .3;
                &:hover{
                  background-color: #ddd;
                  opacity: .7;
                }
              }
            }
            &.cl{
              position: relative;
              padding-left: 46px;
              .clIcon{
                position: absolute;
                display: block;
                width: 16px; height: 16px;
                left: 20px; top: 14px;
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
                opacity: .7;
                &.preview{
                  background-image: url(../assets/public.png);
                }
                &.main{
                  background-image: url(../assets/private.png);
                }
              }
            }
            span.selected{
              float: right;
              margin-top: 12px;
              font-size: 12px;
              font-weight: bold;
              color: #7f95b7;
              letter-spacing: .1px;
              display: none;
            }
            &.selected{
              // background-color: #f5f5fe;
              .selected{
                // display: block;
              }
            }
            &:hover{
              background-color: #eee;
            }
            .price{
              font-weight: bold;
              margin: 0 0 2px;
              span{
                font-weight: normal;
                color: #767676;
                font-size: 15px;
              }
            }
            p{
              font-size: 15px;
              color: #767676;
              margin: 0;
              font-weight: normal;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .theBtn{
        color: #999;
        border-radius: 50px;
        box-sizing: border-box;
        margin-top: 3px;
        cursor: pointer;
        height: 34px;
        display: flex;
        align-items: center;
        padding: 0 14px;
        padding-left: 38px;
        transition: all .3s ease;
        position: relative;
        &:before{
          position: absolute;
          content: "";
          left: 12px; top: 0; bottom: 0; width: 16px;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .65;
        }
        &.lang{
          b{
            text-transform: uppercase;
          }
          &:before{
            background-image: url(../assets/language.png);
          }
        }
        &.date{
          &:before{
            background-image: url(../assets/calendar.png);
          }
        }
        &.category{
          &:before{
            background-image: url(../assets/category-black.png);
          }
        }
        &.section{
          &:before{
            background-image: url(../assets/section.png);
          }
        }
        &:hover{
          background-color: #f5f5fe;
          box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        }
        b{
          color: #444;
          font-weight: 600;
          max-width: 140px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inline-block;
        }
      }
    }
    .saveBtnCnt{
      display: flex;
      float: right;
      position: relative;
      margin-left: 10px;
      .moreOptionOverlay{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 8;
      }
      .moreOption{
        position: absolute;
        bottom: 100%;
        padding: 10px 0;
        right: -10px;
        margin-bottom: 10px;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, .1);
        background-color: #fff;
        text-align: left;
        border: #ccc 1px solid;
        z-index: 9;
        border-radius: 7px;
        &:before{
          position: absolute;
          content: "";
          bottom: -10px; right: 13px;
          border-top: #ccc 10px solid;
          border-left: transparent 10px solid;
          border-right: transparent 10px solid;
        }
        &:after{
          position: absolute;
          content: "";
          bottom: -8px; right: 14px;
          border-top: #fff 9px solid;
          border-left: transparent 9px solid;
          border-right: transparent 9px solid;
        }
        li{
          list-style: none;
          padding: 8px 30px;
          padding-left: 18px;
          white-space: nowrap;
          cursor: pointer;
          position: relative;
          display: flex;
          align-items: center;
          &:before{
            content: "";
            width: 22px; height: 22px;
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 6px;
            opacity: .65;
          }
          &:hover{
            background-color: #eee;
          }
          &.draft{
            &:before{
              background-image: url(../assets/draft-o.png);
              // background-size: 22px;
            }
          }
          &.preview{
            &:before{
              background-image: url(../assets/preview.png);
            }
          }
        }
      }
      .btn{
        float: none;
        box-shadow: none;
        &.btnLoading{
          border-radius: 4px !important;
        }
      }
      .moreBtn{
        background-color: #0057d8;
        width: 26px;
        border-radius: 0 4px 4px 0;
        transition: background-color, color .2s ease;
        border-left: #144691 1px solid;;
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/top-arrow-closed-white.png);
        cursor: pointer;
        display: none;
        &:hover{
          background-color: #0067ff;
        }
      }
      &.disabled{
        .btn,
        .moreBtn{
          background-color: #ccc;
          box-shadow: none;
          cursor: default;
          border-color: #bbb;
        }
      }
      &.canSaveDraft{
        .btn{
          border-radius: 4px 0 0 4px;
          &.loading{
            border-radius: 3px;
            width: 132px;
          }
        }
        .moreBtn{
          display: block;
        }
      }
      &.loading{
        .moreBtn{
          display: none;
        }
      }
    }
    .btnAttachment{
      float: right;
      width: 36px;
      height: 36px;
      position: relative;
      margin-top: 3px;
      .theBtn{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        border-radius: 50%;
        background-image: url(../assets/attachment.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #fff;
        opacity: .5;
        cursor: pointer;
        &:hover{
          background-color: #eee;
          opacity: 1;
        }
      }
    }
    .btnConfig{
      float: right;
      width: 36px;
      height: 36px;
      padding: 0;
      position: relative;
      margin-top: 3px;
      .theBtn{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        border-radius: 50%;
        background-image: url(../assets/settings.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #fff;
        opacity: .5;
        cursor: pointer;
        &:hover{
          background-color: #eee;
          opacity: 1;
        }
      }
      &.metadata{
        .theBtn{
          background-image: url(../assets/metadata.png);
          opacity: .8;
          background-size: 21px auto;
        }
        .configItem{
          margin-bottom: 16px !important;
        }
      }
      .configOverlay{
        position: fixed;
        left: 0; right: 0; bottom: 0; top: 0;
        z-index: 8;
      }
      .configContent{
        position: absolute;
        bottom: 100%;
        width: 240px;
        padding: 20px;
        padding-bottom: 0;
        right: -95px;
        margin-bottom: 10px;
        box-shadow: 1px 1px 2px rgba(0,0,0,.1);
        background-color: #fff;
        text-align: left;
        border: #ccc 1px solid;
        z-index: 9;
        border-radius: 7px;
        &.hasSc{
          padding: 0;
          box-sizing: border-box;
          width: 280px;
          .configSc{
            padding: 20px;
            overflow: auto;
            max-height: 74vh;
          }
        }
        &:before{
          position: absolute;
          content: "";
          left: 50%;
          bottom: -10px;
          margin-left: 16px;
          border-top: #ccc 10px solid;
          border-left: transparent 10px solid;
          border-right: transparent 10px solid;
        }
        &:after{
          position: absolute;
          content: "";
          left: 50%;
          bottom: -8px;
          margin-left: 17px;
          border-top: #fff 9px solid;
          border-left: transparent 9px solid;
          border-right: transparent 9px solid;
        }
        .configItem{
          margin-bottom: 25px;
          h4{
            margin: 0;
            margin-bottom: 5px;
            font-size: 18px;
            font-weight: 500;
            &.h4ci{
              margin-bottom: 10px;
            }
          }
          p{
            margin: 0;
            font-size: 13px;
          }
          .metadataCnt{
            min-height: 240px;
            max-height: 56vh;
            overflow: auto;
            margin: 0 -20px 10px;
            box-sizing: border-box;
            border-top: #eee 1px solid;
            border-bottom: #eee 1px solid;
            &.noData{
              padding: 20px 20px 40px;
              h4{
                font-size: 17px;
                font-weight: 600;
                margin: 0 0 2px;
                color: #444;
              }
              p{
                color: #767676;
                margin: 0;
                font-style: italic;
                font-size: 14px;
              }
            }
            .metadataItem{
              padding: 12px 20px;
              padding-right: 24px;
              position: relative;
              border-bottom: #eee 1px dashed;
              &:last-child{
                padding-bottom: 20px;
                border: none;
              }
              &.sortable-ghost{
                background-color: #eee !important;
                *{
                  opacity: 0;
                }
              }
              &.sortable-chosen{
                background-color: #eee !important;
              }
              &.sortable-drag{
                background-color: #fff !important;
              }
              .metadataHandle{
                position: absolute;
                right: 30px; top: 12px;
                width: 32px; height: 32px;
                border-radius: 50%;
                z-index: 7;
                cursor: pointer;
                background-image: url(../assets/drag-and-drop.png);
                background-size: 14px auto;
                background-position: center;
                background-repeat: no-repeat;
                opacity: .64;
                transition: all .3s ease;
                &:hover{
                  background-color: #f5f5fe;
                  opacity: .86;
                }
              }
              .more{
                position: absolute;
                cursor: pointer;
                top: 0; right: -20px;
                width: 32px; height: 32px;
                border-radius: 50%;
                background-image: url(../assets/more.png);
                background-size: 14px auto;
                background-position: center;
                background-repeat: no-repeat;
                opacity: .64;
                transition: all .3s ease;
                &:hover{
                  background-color: #f5f5fe;
                  opacity: .86;
                }
              }
              .moreMenu{
                position: absolute;
                right: 4px; top: 100%;
                border-radius: 5px;
                border: #eee 1px solid;
                margin-top: -10px;
                padding: 8px 0;
                z-index: 992;
                background-color: #fff;
                box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
                li{
                  white-space: nowrap;
                  padding: 8px 24px;
                  cursor: pointer;
                  font-weight: 400;
                  list-style: none;
                  font-size: 15px;
                  &:hover{
                    background-color: #f5f5fe;
                  }
                }
              }
              .metadataVal{
                word-break: break-all;
              }
              .label{
                padding: 0 0 4px;
                color: #767676;
                border-radius: 40px;
                position: relative;
                transition: all .3s ease;
                .theLabel{
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .field{
                margin: 0;
              }
            }
          }
          .addMetadata{
            font-weight: 500;
            display: block;
            margin: 0;
            font-size: 16px;
          }
          .ciItem{
            font-size: 14px;
            margin-bottom: 8px;
            padding-bottom: 4px;
            border-bottom: #ccc 1px dotted;
            color: #444;
            display: flex;
            align-items: center;
            &.hasDd{
              .dd{
                margin-left: auto;
                color: #444;
                border-radius: 50px;
                border: #eee 1px solid;
                padding: 4px 12px;
                padding-right: 30px;
                position: relative;
                cursor: pointer;
                &:before{
                  content: "";
                  position: absolute;
                  right: 12px; top: 0; bottom: 0;
                  width: 10px;
                  background-image: url(../assets/down-arrow.png);
                  background-size: 10px auto;
                  background-position: center;
                  background-repeat: no-repeat;
                  opacity: .65;
                }
              }
              .ddMenu{
                position: absolute;
                background-color: #fff;
                top: 100%; right: 0;
                box-shadow: 0 0 6px rgba(0, 0, 0, .1);
                border-radius: 5px;
                z-index: 9;
                margin-top: 2px;
                &:before{
                  content: "";
                  position: absolute;
                  right: 8px; top: -8px;
                  border-bottom: #eee 8px solid;
                  border-left: transparent 8px solid;
                  border-right: transparent 8px solid;
                }
                &:after{
                  content: "";
                  position: absolute;
                  right: 10px; top: -6px;
                  border-bottom: #fff 6px solid;
                  border-left: transparent 6px solid;
                  border-right: transparent 6px solid;
                }
                .ddSc{
                  padding: 8px 0;
                  max-height: 200px;
                  overflow: auto;
                }
                li{
                  list-style: none;
                  padding: 5px 24px 7px;
                  padding-right: 10px;
                  font-size: 15px;
                  cursor: pointer;
                  width: 200px;
                  box-sizing: border-box;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  .bull{
                    margin: 0 4px;
                    float: none;
                  }
                  h4{
                    margin: 0;
                    font-size: 15px;
                    font-weight: 600;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  p{
                    font-size: 13px;
                    color: #767676;
                    margin: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  &:hover{
                    background-color: #f5f5fe;
                  }
                }
              }
            }
            span{
              color: #444;
              margin-left: auto;
              &.liSpan{
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
                padding-left: 20px;
              }
            }
            img{
              float: left;
              height: 16px;
              margin: 0 5px 0 0;
            }
            input{
              text-align: right;
              border: none;
              outline: 0;
              max-width: 100px;
              margin-left: auto;
            }
            .sw{
              width: 36px;
              height: 20px;
              background-color: #ccc;
              border: #ccc 1px solid;
              border-radius: 50px;
              margin-left: auto;
              position: relative;
              cursor: pointer;
              transition: all .2s ease;
              &:before{
                content: "";
                position: absolute;
                left: 1px; top: 1px;
                width: 18px; height: 18px;
                background-color: #fff;
                box-shadow: 2px 2px 3px rgba(0,0,0,.1);
                border-radius: 50%;
                transition: all .2s ease;
              }
              &.on{
                background-color: #ec174c;
                border-color: #ec174c;
                &:before{
                  left: 17px;
                }
              }
              &.disabled{
                background-color: #ccc;
                border-color: #ccc;
                cursor: default;
                &:before{
                  left: 1px;
                  background-color: #ddd;
                  box-shadow: none;
                }
              }
            }
            span{
              float: right;
              color: #767676;
            }
          }
        }
        .field{
          font-size: 15px;
          padding: 8px 10px;
          margin-top: 10px;
        }
      }
    }
  }
}

.priceOk{
  position: relative;
  margin-top: -8px;
  .priceNav{
    position: absolute;
    top: 52px; width: 34px; height: 34px;
    border-radius: 50%;
    background-color: #fff;
    background-size: 16px auto;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 9;
    cursor: pointer;
    transition: all .3s ease;
    display: none;
    &:hover{
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    }
    &.n{
      right: -17px;
      background-image: url(../assets/right-arrow.png);
    }
    &.p{
      background-image: url(../assets/left-arrow.png);
      left: -17px;
    }
  }
  .priceSc{
    overflow: hidden;
    padding-top: 10px;
    position: relative;
  }
}
.prizeCnt{
  display: flex;
  flex-wrap: wrap;
  width: 100% !important;
  transition: all .3s ease;
  &.prize1{ margin-left: -130px; }
  &.prize2{ margin-left: calc(-130px * 2); }
  &.prize3{ margin-left: calc(-130px * 3); }
  &.prize4{ margin-left: calc(-130px * 4); }
  &.prize5{ margin-left: calc(-130px * 5); }
  &.prize6{ margin-left: calc(-130px * 6); }
  &.prize7{ margin-left: calc(-130px * 7); }
  &.prize8{ margin-left: calc(-130px * 8); }
  &.prize9{ margin-left: calc(-130px * 9); }
  &.prize10{ margin-left: calc(-130px * 10); }
  &.prize11{ margin-left: calc(-130px * 11); }
  &.prize12{ margin-left: calc(-130px * 12); }
  &.prize13{ margin-left: calc(-130px * 13); }
  &.prize14{ margin-left: calc(-130px * 14); }
  &.prize15{ margin-left: calc(-130px * 15); }
  &.prize16{ margin-left: calc(-130px * 16); }
  &.prize17{ margin-left: calc(-130px * 17); }
  &.prize18{ margin-left: calc(-130px * 18); }
  &.prize19{ margin-left: calc(-130px * 19); }
  &.prize20{ margin-left: calc(-130px * 20); }
  &.prize21{ margin-left: calc(-130px * 21); }
  &.prize22{ margin-left: calc(-130px * 22); }
  &.prize23{ margin-left: calc(-130px * 23); }
  &.prize24{ margin-left: calc(-130px * 24); }
  &.prize25{ margin-left: calc(-130px * 25); }
  &.prize26{ margin-left: calc(-130px * 26); }
  &.prize27{ margin-left: calc(-130px * 27); }
  &.prize28{ margin-left: calc(-130px * 28); }
  &.prize29{ margin-left: calc(-130px * 29); }
  &.prize30{ margin-left: calc(-130px * 30); }
  .prizeItem{
    margin: 0 10px 10px 0;
    h4{
      margin: 5px 0 0;
      font-size: 14px;
      text-align: center;
      font-weight: 600;
    }
    p{
      text-align: center;
      margin: 0;
      font-size: 10px;
      color: #767676;
    }
  }
}
.catImg{
  width: 120px; height: 120px;
  background-color: #eee;
  border-radius: 5px;
  margin-right: auto;
  position: relative;
  transition: background-color, box-shadow .3s ease;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  cursor: pointer;
  &:before{
    content: "";
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    opacity: .3;
    background-image: url(../assets/image-black.png);
    background-size: 46px auto;
    background-position: center;
    background-repeat: no-repeat;
    transition: all .3s ease;
  }
  .moreMenu{
    position: absolute;
    background-color: #fff;
    padding: 10px 0;
    box-shadow: 2px 2px 4px rgba(0,0,0,.2);
    border-radius: 3px;
    right: 6px; top: 6px;
    li{
      list-style: none;
      padding: 4px 16px;
      font-size: 15px;
      white-space: nowrap;
      transition: all .3s ease;
      cursor: pointer;
      &.red{
        color: red;
      }
      &:hover{
        background-color: #f5f5fe;
      }
    }
  }
  .more{
    background-color: #fff;
    width: 30px; height: 30px;
    position: absolute;
    right: -5px; top: -4px;
    border-radius: 50%;
    background-image: url(../assets/more.png);
    background-repeat: no-repeat;
    background-size: 12px auto;
    background-position: center;
    transition: opacity .3s ease;
    transition: all .3s ease;
    cursor: pointer;
    box-shadow: 2px 2px 4px rgba(0,0,0,.1);
    &:hover{
      opacity: 1;
      box-shadow: 2px 2px 6px rgba(0,0,0,.2);
    }
  }
  &.hasImg{
    &:before{
      display: none;
    }
  }
  &:hover{
    background-color: #e5e5e5;
    // box-shadow: 2px 2px 4px rgba(0,0,0,.2);
    &:before{
      opacity: .4;
    }
  }
  &.addPrize{
    font-size: 13px;
    font-weight: 600;
    color: #999;
    text-align: center;
    padding: 24px 0 0;
    text-transform: uppercase;
    cursor: pointer;
    span{
      display: block;
      font-size: 36px;
      font-weight: 400;
      margin: 0 0 -4px;
      img{
        height: 30px;
        opacity: .3;
      }
    }
    &:before{
      display: none;
    }
  }
}
.cmsriverCnt{
  position: fixed;
  right: 24px; bottom: 74px;
  width: 52px; height: 52px;
  background-color: #fff;
  border-radius: 50%;
  .cmsriverResult{
    position: absolute;
    background-color: #fff;
    bottom: 100%; right: 0;
    width: 340px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
    border-radius: 5px;
    border: #eee 1px solid;
    margin-bottom: 10px;
    padding-bottom: 58px;
    visibility: hidden;
    transform-origin: right bottom;
    transform: scale(.9);
    opacity: 0;
    padding-top: 10px;
    &.open{
      visibility: visible;
      transform: none;
      opacity: 1;
    }
    .text{
      padding: 16px 20px;
      max-height: 52vh;
      border-top: #eee 1px solid;
      overflow: auto;
    }
    .actions{
      position: absolute;
      left: 0; right: 0; bottom: 0;
      padding: 10px 20px;
      text-align: right;
      border-top: #eee 1px solid;
      .btn{
        padding: 10px 12px;
        font-size: 15px;
        font-weight: 600;
        margin-left: 10px;
      }
    }
  }
  .cmsriver{
    background-image: url(../assets/cmsriver-logo.png);
    background-size: 42px auto;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
    width: 52px; height: 52px;
    border-radius: 50%;
    z-index: 3;
    transition: all .3s ease;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    &:after{
      content: "";
      position: absolute;
      top: -10px; right: -10px; left: -10px; bottom: -10px;
      border-radius: 50%;
      background-image: url(../assets/loading-3.svg);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    &:before{
      content: "";
      position: absolute;
      border: #0057d8 2px solid;
      top: 0; right: 0; left: 0; bottom: 0;
      border-radius: 50%;
    }
    .info{
      position: absolute;
      right: 100%;
      background-color: #222;
      padding: 4px 10px;
      border-radius: 3px;
      font-size: 12px;
      white-space: nowrap;
      color: #fff;
      top: 50%;
      transform: translate(-10px, -50%);
      margin-right: 10px;
      transition: all .3s ease;
      opacity: 0;
      visibility: hidden;
      &:before{
        content: "";
        position: absolute;
        right: -5px;
        border-left: #222 6px solid;
        border-top: transparent 6px solid;
        border-bottom: transparent 6px solid;
      }
    }
    &:hover{
      transform: scale(1.04);
      .info{
        transform: translateY(-50%);
        visibility: visible;
        opacity: 1;
      }
    }
  }
  &.loading{
    .cmsriver{
      transform: none;
      filter: grayscale(1);
      opacity: .65;
      &:after{
        opacity: 1;
      }
    }
  }
}
</style>
